import React from "react";
import Wrapper from "../hooks/wrapper";
import YouTube from "react-youtube";
import { NavLink } from "react-router";

import "../Components.css";
import videoData from "../data/videos.json";

const productionVideos = videoData.info
  .filter((item) => item.categories === "production")
  .map((info, index) => {
    const opts = {
      height: "390",
      width: "640",
      playerVars: {
        autoplay: 0,
      },
    };

    return (
      <div key={index} style={{ marginBottom: "50px" }}>
        <YouTube videoId={info.url} opts={opts} />
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <span style={{ fontWeight: 700 }}>{info.name}</span>
          <span style={{ whiteSpace: "pre-line" }}>{info.desc}</span>
        </div>
      </div>
    );
  });

const subcontractVideos = videoData.info
  .filter((item) => item.categories === "subcontract")
  .map((info, index) => {
    const opts = {
      height: "390",
      width: "640",
      playerVars: {
        autoplay: 0,
      },
    };

    return (
      <div key={index} style={{ marginBottom: "50px" }}>
        <YouTube videoId={info.url} opts={opts} />
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <span style={{ fontWeight: 700 }}>{info.name}</span>
          <span style={{ whiteSpace: "pre-line" }}>{info.desc}</span>
        </div>
      </div>
    );
  });

function Videos() {
  return (
    <Wrapper>
      <div className="Pages">
        <div className="PageTitle">
          <span>VIDEOS</span>
          <NavLink to="/">← Previous</NavLink>
        </div>
        <div className="PageContent">
          <div>
            <span className="PageSubtitle">PRODUCTION</span>
            <div className="Youtube">{productionVideos}</div>
          </div>
          <div>
            <span className="PageSubtitle">OUTSOURCING</span>
            <div className="Youtube">{subcontractVideos}</div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Videos;
